import React from 'react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';

/** Per-report layout: "tabs" (existing tab bar) or "document" (tree + content). */
export type SitrepLayoutMode = 'tabs' | 'document';

export const LAYOUT_OPTIONS: {
  value: SitrepLayoutMode;
  label: string;
}[] = [
  { value: 'tabs', label: 'Tabs' },
  { value: 'document', label: 'Document' },
];

type SitrepLayoutSwitcherProps = {
  value: SitrepLayoutMode;
  onChange: (mode: SitrepLayoutMode) => void;
  className?: string;
};

/**
 * Vertical-ellipsis dropdown for switching a SITREP's section layout between
 * tabs and document view. Safe to render inside a clickable card header —
 * clicks do not bubble up to the collapse toggle.
 */
const SitrepLayoutSwitcher: React.FC<SitrepLayoutSwitcherProps> = ({
  value,
  onChange,
  className,
}) => {
  return (
    <span
      role="presentation"
      className={className}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <DropdownMenu>
        <DropdownMenuTrigger
          render={
            <Button
              variant="outline"
              size="icon-sm"
              aria-label="Change section layout"
              title="Change section layout"
            />
          }
        >
          <SharedIcon iconName="more_vert" size="sm" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuRadioGroup
            value={value}
            onValueChange={(newValue: SitrepLayoutMode) => onChange(newValue)}
          >
            <DropdownMenuLabel>Layout</DropdownMenuLabel>
            {LAYOUT_OPTIONS.map((option) => (
              <DropdownMenuRadioItem
                key={option.value}
                value={option.value}
                closeOnClick
              >
                {option.label}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </span>
  );
};

export default SitrepLayoutSwitcher;
